import { SortingRule } from "react-table";
import { LeadSimpleFilterTypes } from "enums/leads-simple-filter-type.enum";
import {
  LeadDateRangeFilterEnum,
  LeadNextActionDateFilterEnum,
} from "enums/lead-next-action-date-filter.enum";
import {
  TLeadFilterMenuItemData,
  TLeadsFilter,
} from "../types/leads-filter.type";

export const findPrimaryOptionForSecondaryValue = (
  map: Record<string, TLeadFilterMenuItemData[]>,
  targetValue: string | number
) => {
  for (const [key, valueArray] of Object.entries(map)) {
    if (valueArray.some(item => item.value === targetValue)) {
      return key;
    }
  }
  return null;
};

const UNFILTERED_DATE_FILTER_TYPES: string[] = [
  LeadNextActionDateFilterEnum.ALL,
  LeadDateRangeFilterEnum.ALL,
];

const isEmptyFilterValue = (value: unknown): boolean => {
  if (value === null || value === undefined) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value !== "object") return false;

  const { type: dateFilterType } = value as { type?: string };
  if (dateFilterType !== undefined) {
    return UNFILTERED_DATE_FILTER_TYPES.includes(dateFilterType);
  }

  return Object.keys(value).length === 0;
};

export const hasUserLeadsFilters = (filter: TLeadsFilter) =>
  Object.entries(filter).some(
    ([key, value]) =>
      key !== LeadSimpleFilterTypes.STAGES && !isEmptyFilterValue(value)
  );

export const isDefaultLeadsSort = (sortBy: SortingRule<string>[]) =>
  sortBy.length === 0 ||
  (sortBy.length === 1 && sortBy[0].id === "createdAt" && !!sortBy[0].desc);
